import React from 'react';

import styled from '@emotion/styled';

const pluralize = (word: string): string => {
  const lower = word.toLowerCase();
  if (lower.endsWith('y')) return lower.slice(0, -1) + 'ies';
  if (lower.endsWith('s')) return lower + 'es';
  return lower + 's';
};

const DispatchVolumeTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const vehicleType: string = payload[0]?.payload?.vehicleType ?? '';
    const pluralType = pluralize(vehicleType);

    const labels = [`Amount of ${pluralType}`, `Companies using ${pluralType}`];

    return (
      <TooltipContainer>
        {payload.map((entry: any, index: number) => (
          <TooltipRow key={`item-${index}`}>
            <ColorDot color={entry.color} />
            <TooltipLabel>{labels[index] ?? entry.name}:</TooltipLabel>
            <TooltipValue>{entry.value}</TooltipValue>
          </TooltipRow>
        ))}
      </TooltipContainer>
    );
  }
  return null;
};

export default DispatchVolumeTooltip;

const TooltipContainer = styled.div`
  background: white;
  border-radius: 6px;
  padding: 4px 12px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ColorDot = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  flex-shrink: 0;
`;

const TooltipLabel = styled.span`
  font-size: 10px;
  color: #6b7280;
  font-weight: 400;
`;

const TooltipValue = styled.span`
  font-size: 12px;
  color: #000000;
  font-weight: 500;
`;
